import React from "react";
import CSSModules from "lib/utils/css-modules";

import styles from "./HintView.less";

@CSSModules(styles)
class HintViewContainer extends React.PureComponent {
  static displayName = "HintView.Container";

  render() {
    const { children, ...rest } = this.props;
    return (
      <div styleName="view" {...rest}>
        {children}
      </div>
    );
  }
}

@CSSModules(styles)
class HintViewSidebar extends React.PureComponent {
  static displayName = "HintView.Sidebar";

  render() {
    const { children, ...rest } = this.props;
    return (
      <div styleName="sidebar" {...rest}>
        {children}
      </div>
    );
  }
}

@CSSModules(styles)
class HintViewContent extends React.PureComponent {
  static displayName = "HintView.Content";

  render() {
    const { children, ...rest } = this.props;
    return (
      <div styleName="content" {...rest}>
        {children}
      </div>
    );
  }
}

@CSSModules(styles)
class HintViewHint extends React.PureComponent {
  static displayName = "HintView.Hint";

  render() {
    const { children, ...rest } = this.props;
    return (
      <div styleName="hint" {...rest}>
        {children}
      </div>
    );
  }
}

export default {
  Container: HintViewContainer,
  Sidebar: HintViewSidebar,
  Content: HintViewContent,
  Hint: HintViewHint,
};



// WEBPACK FOOTER //
// ./src/lib/components/HintView.jsx